export default "__VITE_ASSET__BCLMi5ic__"